// SPDX-License-Identifier: AGPL-3.0-or-later

import * as ShopierCommands from '@app/features/premium/commands/ShopierCommands';
import {openShopierPopup, ShopierCheckoutModal} from '@app/features/premium/components/experience/ShopierCheckoutModal';
import * as ModalCommands from '@app/features/ui/commands/ModalCommands';
import {modal} from '@app/features/ui/commands/ModalCommands';
import type {
	ShopierCosmeticKindSchema,
	ShopierPlanSchema,
	ShopierPurchaseResponse,
} from '@fluxer/schema/src/domains/premium/ShopierSchemas';
import type {MessageDescriptor} from '@lingui/core';

export function parseAmount(price: string | null): number | null {
	if (!price) return null;
	const value = Number(price.replace(',', '.'));
	return Number.isFinite(value) && value > 0 ? value : null;
}

export function formatMoney(amount: number, currency: string | null, locale: string): string {
	try {
		return new Intl.NumberFormat(locale, {
			style: 'currency',
			currency: currency ?? 'TRY',
			minimumFractionDigits: Number.isInteger(amount) ? 0 : 2,
			maximumFractionDigits: 2,
		}).format(amount);
	} catch {
		return `${amount} ${currency ?? ''}`.trim();
	}
}

export function startShopierCheckout(plan: ShopierPlanSchema, onFinished: () => void): void {
	openCheckout(() => ShopierCommands.createShopierPurchase(plan), onFinished);
}

export function startStoreCheckout(
	kind: ShopierCosmeticKindSchema,
	itemId: string,
	onFinished: () => void,
	success?: {title: MessageDescriptor; body: MessageDescriptor},
): void {
	openCheckout(() => ShopierCommands.createStorePurchase(kind, itemId), onFinished, success);
}

/** Opens the payment window right inside the click (so it is not blocked) and the status dialog. */
function openCheckout(
	create: () => Promise<ShopierPurchaseResponse>,
	onFinished: () => void,
	success?: {title: MessageDescriptor; body: MessageDescriptor},
): void {
	const popup = openShopierPopup();
	ModalCommands.push(
		modal(() => <ShopierCheckoutModal create={create} success={success} popup={popup} onFinished={onFinished} />),
	);
}
